function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill-rule: evenodd;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M385.156,125c48.9-.554,100.089,5.855,121.094,32.422,12.582,15.913,17.325,37.978,23.047,60.937,5.1,20.47,11.086,59.114.781,78.907-0.541-12.47-3.923-23.04-7.031-33.2-9.014-29.474-15.808-71.972-42.578-83.593-22.625-9.821-63.014-6.252-92.969-6.25-24.36,0-56.475-2.523-72.266,7.031-24.087,14.574-34.52,61.026-42.968,91.8q-2.149,11.718-4.3,23.437h-0.391l-4.687-22.656c-2.334-14.369,1.082-31.409,3.515-42.969,7.734-36.743,14.274-70.242,42.188-86.718,13.158-7.767,29.337-12.445,46.484-16.016Z"
});

var SvgOmHairstyleBuzzFrontVector = function SvgOmHairstyleBuzzFrontVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "om_hairstyle_buzz_front",
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOmHairstyleBuzzFrontVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/om_hairstyle_buzz_front_vector.cf24e687.svg";
export { ForwardRef as ReactComponent };